import { api } from '@services';

import { IInviteApiModel } from '@models/Invite.model';

interface IAcceptInvite {
  id: string;
  name: string;
  password: string;
}

const acceptInvite = async ({
  id,
  name,
  password,
}: IAcceptInvite): Promise<void> => {
  await api.post<IInviteApiModel>(`/invites/${id}/accept`, {
    name,
    password,
  });
};

export { acceptInvite };
